import { UserDetailComponent } from './user-detail.component';

export default UserDetailComponent;
